import axios from 'axios';

// export const baseURL = 'http://localhost:6001/api/';
export const baseURL = 'https://kbmc.gov.in/api/api/';
const api = axios.create({
baseURL,
});
export default api; 